export function firstSymbol(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase();
}